import {Axios} from '../axios/axios.js'
//faliure list
export const getfailList = (e) => {
  return Axios({
    url:"/task/failure_task_list",
    method:'put',
    data:e
  })
}
//faliure note  /task/add_audit_note
export const updatefailNote = (e) => {
  return Axios({
    url:"/task/add_audit_note",
    method:'put',
    data:e
  })
}
//task switch /task/audit_task
export const changeSwitch = (e) => {
  return Axios({
    url:"/task/audit_task",
    method:'put',
    data:e
  })
}
//到处失败任务 /task/export_failed_tasks
export const exportFailTasks = (e) => {
  return Axios({
    url:"/task/export_failed_tasks",
    method:'put',
    data:e
  })
}
